import React, { useState, useEffect } from 'react';
import ReactTooltip from "react-tooltip";
import Reaptcha from 'reaptcha';
import api from '~/services/api';
import { Container, Pergunta } from './stylesCardioVascular';
import { Select, ButtonPadraoPrimary } from '~/styles/CommonStyles';
import Toastify from "~/components/Toastify";
import getUrlParameter from '~/helpers/getURLencode';

import { useRecoilState } from 'recoil';
import { mensagemConformidadeLGPD } from '../../atoms/conformidade';

function Cardiovascular ( { location } ) {
    const params = new URLSearchParams( location.search );
    const _CHAVE = params.get( 'chave' ) || "Z/ZbpVyPy70HZWGI6OcUhU3nTnB3wXQPWMnPQPkVL7iZHvWwbrKnq6emHNfqI1kOS/YHf/r9X1Y=";
    const [ recaptchaToken, setRecaptchaToken ] = useState( null );
    const [ conformidadeMensagem, setConformidadeMensagem ] = useRecoilState( mensagemConformidadeLGPD );
    const [ objPerfil, setObjPerfil ] = useState( {
        historicofamiliar: '',
        fadiga: '',
        fumante: '',
        comorbidade: '',
        Chave: _CHAVE,
        responsecaptcha: '',
    } );

    useEffect( () => {
        setObjPerfil( { ...objPerfil, responsecaptcha: recaptchaToken } );
    }, [ recaptchaToken ] );

    useEffect( () => {
        setConformidadeMensagem( { popUpOpen: true } );
    }, [] );



    async function salvar () {
        try {
            let erro = verficaCampo( objPerfil );

            if ( erro )
                return Toastify.warning( erro );

            if ( !recaptchaToken )
                return Toastify.warning( 'Por favor, faça a verificação do "captcha" ' );


            let retorno = await salvaPerfil( objPerfil );
            Toastify.success( 'Resposta enviadas com sucesso' );

        } catch ( error ) {
            console.log( error );
        }
    };

    return (
        <Container>
            <h1 style={ { textAlign: 'center' } }>Meu perfil cardiovascular</h1>
            <Pergunta>
                <h3>Possui histórico familiar de AVC ou Infarto Agudo do Miocárdio antes dos 50 anos de idade?</h3>
                <Select onChange={ ( e ) => setObjPerfil( { ...objPerfil, historicofamiliar: e.target.value == 'S' ? "S" : e.target.value == 'null' ? '' : "N" } ) }>
                    <option value="null"></option>
                    <option value={ "S" }>Sim</option>
                    <option value={ "N" }>Não</option>
                </Select>
            </Pergunta>
            <Pergunta>
                <h3>Possui fadiga ou cansaço crônico?</h3>
                <Select onChange={ ( e ) => setObjPerfil( { ...objPerfil, fadiga: e.target.value == 'S' ? "S" : e.target.value == 'null' ? '' : "N" } ) } >
                    <option value="null"></option>
                    <option value={ "S" }>Sim</option>
                    <option value={ "N" }>Não</option>
                </Select>
            </Pergunta>
            <Pergunta>
                <h3>Você é fumante?</h3>
                <Select onChange={ ( e ) => setObjPerfil( { ...objPerfil, fumante: e.target.value == 'S' ? "S" : e.target.value == 'null' ? '' : "N" } ) }>
                    <option value="null"></option>
                    <option value={ "S" }>Sim</option>
                    <option value={ "N" }>Não</option>
                </Select>
            </Pergunta>
            <Pergunta>
                <h3>Você possui alguma doença crônica?</h3>
                <Select onChange={ ( e ) => setObjPerfil( { ...objPerfil, comorbidade: e.target.value ? e.target.value : '' } ) } >
                    <option value="null"></option>
                    <option value="N">Não</option>
                    <option value="HAS">Hipertensão Arterial Sistêmica</option>
                    <option value="DM">Diabetes Mellitus</option>
                    <option value="O">Outra doença crônica</option>
                </Select>
            </Pergunta>
            <div style={ { display: 'flex', gap: '10px', width: '100%', flexDirection: 'column', alignItems: 'center' } }>
                <Reaptcha
                    sitekey="6LfrDqgZAAAAABATEykmT5tqdYVnvx0B7Fm3Ahj3"
                    onVerify={ ( value ) => setRecaptchaToken( value ) }
                    onExpire={ () => setRecaptchaToken( null ) }
                />
                <a data-tip data-for='btnHome' >
                    <ButtonPadraoPrimary disabled={ !recaptchaToken } onClick={ () => salvar() }>
                        Salvar
                    </ButtonPadraoPrimary>
                </a>
                <ReactTooltip delayShow={ 300 } id='btnHome' place="bottom" type="dark" effect="solid">
                    { recaptchaToken ? <span>Salvar</span> : <span>Antes selecione o captcha de verificação (Não sou o robô)</span> }
                </ReactTooltip>

            </div>
        </Container>
    );
};

export default Cardiovascular;

async function salvaPerfil ( obj ) {
    try {
        let { data } = await api.post( `/apoio/salvarPerfilRCV`, obj );

        return data;

    } catch ( error ) {
        console.log( error );
        return Promise.reject( error );;
    }
};

function verficaCampo ( obj ) {

    if ( obj.historicofamiliar == '' )
        return 'Preencha o campo de "Historico Familiar".';
    if ( obj.fadiga == '' )
        return 'Preencha o campo de "Fadiga".';
    if ( obj.fumante == '' )
        return 'Preencha o campo de "Tabagismo".';
    if ( obj.comorbidade == '' )
        return 'Preencha o campo de "Comorbidade".';
    if ( obj.Chave == null )
        return 'Não é possivel fazer essa operação, pagina sem chave.';
    if ( obj.responsecaptcha == null )
        return 'Por favor clique no captcha, para efetuar a solicitação.';

    return false;

};
